"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-nested-ternary */
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment"));
var InputLabel_1 = __importDefault(require("@material-ui/core/InputLabel"));
var TextField_1 = __importDefault(require("@material-ui/core/TextField"));
var Visibility_1 = __importDefault(require("@material-ui/icons/Visibility"));
var VisibilityOff_1 = __importDefault(require("@material-ui/icons/VisibilityOff"));
var lodash_1 = require("lodash");
var react_1 = __importDefault(require("react"));
var GenericFormTextField = function (_a) {
    var item = _a.item, fields = _a.fields, values = _a.values, setFieldValue = _a.setFieldValue, changeField = _a.changeField, onChangeEvent = _a.onChangeEvent, onClickEvent = _a.onClickEvent, onDropEvent = _a.onDropEvent, onDragOverEvent = _a.onDragOverEvent, onDragLeaveEvent = _a.onDragLeaveEvent, errors = _a.errors;
    var _b, _c;
    var _d = react_1.default.useState(fields && fields[item.stateKey]
        ? fields[item.stateKey]
        : values && values[item.stateKey]
            ? values[item.stateKey]
            : ""), value = _d[0], setValue = _d[1];
    var field = lodash_1.get(fields, item.stateKey, null);
    react_1.default.useEffect(function () {
        if (field) {
            setValue(field);
        }
        else {
            setValue("");
        }
    }, [fields, field]);
    var _e = react_1.default.useState(false), showPassword = _e[0], setShowPw = _e[1];
    var getPasswordFieldType = showPassword ? "text" : "password";
    if (item.stateKey === "" && item.label === "")
        return react_1.default.createElement(Grid_1.default, { item: true, xs: 12 });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        item.isLabelOutField && (react_1.default.createElement(Grid_1.default, { container: true, style: { marginBottom: item.iconLabel ? "0px" : "6px" } },
            react_1.default.createElement(Grid_1.default, { item: true },
                react_1.default.createElement(InputLabel_1.default, null, item.label)),
            item.iconLabel && react_1.default.createElement(Grid_1.default, { item: true }, item.iconLabel))),
        react_1.default.createElement(TextField_1.default, { id: item.idHtml || item.stateKey, onDrop: function (e) {
                if (onDropEvent)
                    return onDropEvent(item.stateKey, e);
                return null;
            }, onDragOver: function (e) {
                if (onDragOverEvent)
                    return onDragOverEvent(item.stateKey, e);
                return null;
            }, onDragLeave: function (e) {
                if (onDragLeaveEvent)
                    return onDragLeaveEvent(item.stateKey, e);
                return null;
            }, key: item.stateKey, name: item.stateKey, value: value, onChange: function (e) {
                if (item.validateOnChange) {
                    if (setFieldValue) {
                        setFieldValue(item.stateKey, e.target.value);
                    }
                    setValue(e.target.value);
                }
                if (onChangeEvent) {
                    onChangeEvent(item.stateKey, e);
                }
                setValue(e.target.value);
            }, onClick: function (e) {
                if (onClickEvent) {
                    onClickEvent(item.stateKey, e);
                }
            }, multiline: (_b = item.isMultiline) !== null && _b !== void 0 ? _b : false, rows: item.multilineMinRows, rowsMax: item.multilineMaxRows, placeholder: item.isLabelOutField ? undefined : item.placeholder, onBlur: function (e) {
                var _a;
                if (setFieldValue)
                    setFieldValue(item.stateKey, e.target.value);
                if (changeField)
                    changeField({
                        key: item.stateKey,
                        value: ((_a = Object(item)) === null || _a === void 0 ? void 0 : _a.hasOwnProperty("id")) ? { id: item.id, value: e.target.value }
                            : e.target.value,
                    });
            }, fullWidth: true, type: item.isPassword ? getPasswordFieldType : (_c = item.type) !== null && _c !== void 0 ? _c : "", variant: "outlined", label: item.isLabelOutField ? undefined : item.label, disabled: item.disabled, error: !!lodash_1.get(errors, item.stateKey, null) ||
                !!lodash_1.get(errors, item.error, null), helperText: lodash_1.get(errors, item.stateKey, null) ||
                lodash_1.get(errors, item.error, null), InputProps: item.isPassword || (item === null || item === void 0 ? void 0 : item.tooltip)
                ? {
                    endAdornment: (react_1.default.createElement(InputAdornment_1.default, { position: "end" }, (item === null || item === void 0 ? void 0 : item.tooltip) ? (item.tooltip) : (react_1.default.createElement(IconButton_1.default, { "aria-label": "toggle password visibility", onClick: function () { return setShowPw(!showPassword); }, onMouseDown: function (e) { return e.preventDefault(); } }, showPassword ? react_1.default.createElement(Visibility_1.default, null) : react_1.default.createElement(VisibilityOff_1.default, null))))),
                }
                : item.prefix
                    ? {
                        startAdornment: (react_1.default.createElement(InputAdornment_1.default, { position: "start" }, item.prefix)),
                    }
                    : undefined })));
};
exports.default = GenericFormTextField;
//# sourceMappingURL=GenericFormTextField.js.map